import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HorizontalNavComponent } from './horizontal-nav.component';
import { HorizontalNavBasicItemComponent } from './horizontal-nav-basic-item.component';
import { HorizontalNavBranchItemComponent } from './horizontal-nav-branch-item.component';
import { HorizontalNavSpacerItemComponent } from './horizontal-nav-spacer-item.component';

@NgModule({
    declarations: [
        HorizontalNavComponent,
        HorizontalNavBasicItemComponent,
        HorizontalNavBranchItemComponent,
        HorizontalNavSpacerItemComponent
    ],
    imports: [CommonModule, RouterModule, MatIconModule, MatMenuModule, MatTooltipModule],
    exports: [HorizontalNavComponent]
})
export class AppNavigationModule {}
